export default {
	methods: {
		appUiLocationChange($event,app,list) {
			let vm = this

			//UI location needs to be updated
			let payload = {
				ui_location: $event 
			}

			if ("AddonAppInstalled" in app)
				payload.id = app.AddonAppInstalled[0].id
			else if ("AddonApp" in app)
				payload.id = app.id

			this.postData("AddonAppInstalled/save",payload,true).then(response => {
				if (response.success) {
					vm.fetchCompanyData(false,["CompanySetting","AddonApp"])
					vm.alertSuccess("Install location changed")
				}
			})
			
		},
		uninstallApp(appIndex) {
			let vm = this

			let sync = this.primitize(this.installedApps)

			//remove from array of istalled apps
			sync.splice(appIndex,1)

			let payload = {
				id: this.$store.company.id,
				AddonApp: sync
			}

			return new Promise((resolve,reject) => {

				vm.postData("Company/save",payload,true).then(response => {
					if (response.success) {
						vm.alertSuccess("App un-installed")

						vm.fetchCompanyData(false,["CompanySetting","AddonApp"])

						resolve(response)
					}
				})

			})
		},
		fetchInstalledApps() {
			let vm = this

			this.spinner(true)

			let params = {
				include: [
					"AddonAppInstalled",
					{model: "User",fields: ["id","slug","first_name","last_name"]}
				],
				filters: [
					["AddonAppInstalled.tenant_id",this.$store.company.id]
				]
			}

			this.getJSON("AddonApp/get",params,true).then(response => {
				vm.spinner(false)

				if (response.success) {
					vm.installedApps = response.data.map(app => {
						app.showInstallLocation = true

						return app
					})
				}
			})
		}
	}
}